import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import { getDarkTableRow } from "../../../../Utils/otherFunctions";
import TabModalDetailSS from "./TabModalDetailSS";
import { formatRP } from "../../../../Utils/externalFunctions";
import { useThemeContext } from "../../../../Context/ThemeContext";

const ModalDetailCapaianSS = ({
  rincianModalOpen,
  toggleRincianModal,
  selectedCapaian,
}) => {
  const { themeContext } = useThemeContext();

  return (
    <>
      <Modal
        isOpen={rincianModalOpen}
        toggle={() => toggleRincianModal(selectedCapaian)}
        size="xl"
        scrollable={true}
      >
        <ModalHeader toggle={() => toggleRincianModal(selectedCapaian)}>
          Rincian Capaian SS
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              {selectedCapaian ? (
                <>
                  <Row>
                    <Col>
                      <Table hover>
                        <tbody>
                          <tr>
                            <td
                              className={
                                "align-center" + getDarkTableRow(themeContext)
                              }
                            >
                              <strong>Entitas</strong>
                            </td>
                            <td
                              className={
                                "align-center" + getDarkTableRow(themeContext)
                              }
                            >
                              {selectedCapaian.entitas}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Perspektif</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              {selectedCapaian.perspektif}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Kode SS</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              {selectedCapaian.kode_ss}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Nama SS</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              <p>{selectedCapaian.nama_ss}</p>
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Bobot SS</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              {selectedCapaian.bobot_sasaran_strategis}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <Col>
                      <Table hover>
                        <tbody>
                          <tr>
                            <td
                              className={
                                "align-center" + getDarkTableRow(themeContext)
                              }
                            >
                              <strong>Anggaran</strong>
                            </td>
                            <td
                              className={
                                "align-center" + getDarkTableRow(themeContext)
                              }
                            >
                              Rp. {formatRP(selectedCapaian.anggaran)}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Komitmen</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              Rp. {formatRP(selectedCapaian.komitmen)}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Aktual</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              Rp. {formatRP(selectedCapaian.aktual)}
                            </td>
                          </tr>
                          <tr>
                            <td className={getDarkTableRow(themeContext)}>
                              <strong>Sisa Anggaran</strong>
                            </td>
                            <td className={getDarkTableRow(themeContext)}>
                              <p>
                                Rp. {formatRP(selectedCapaian.sisa_anggaran)}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <TabModalDetailSS selectedCapaian={selectedCapaian} />
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalDetailCapaianSS;
